import { styled } from '~/styled'

export const ChipGroup = styled('div', {
  base: ['flex', 'flex-row', 'flex-wrap', 'gap-2']
})
